// v-scroll-autohide — the element's scrollbar keeps its space but stays
// invisible until the element is actually scrolled (.scroll-autohide in
// tailwind.css). `v-scroll-autohide="false"` turns it off, e.g. for a shared
// container that only wants it on some routes.
const HIDE_AFTER_MS = 800

function apply(el, on) {
  el.classList.toggle('scroll-autohide', on !== false)
}

export const vScrollAutohide = {
  mounted(el, { value }) {
    apply(el, value)
    let timer = null
    el._scrollAutohide = () => {
      el.classList.add('is-scrolling')
      clearTimeout(timer)
      timer = setTimeout(() => el.classList.remove('is-scrolling'), HIDE_AFTER_MS)
    }
    el.addEventListener('scroll', el._scrollAutohide, { passive: true })
  },
  // Re-applied after every patch: a :class binding on the same element
  // rewrites className and would drop the class otherwise.
  updated(el, { value }) { apply(el, value) },
  unmounted(el) { el.removeEventListener('scroll', el._scrollAutohide) },
}
